import get from 'lodash/get';
import { createSelector } from 'reselect';

import { getUserOrgId } from 'common/store/user/selectors';
import { getEventId } from 'common/store/events/selectors';
import { getEventOrgId } from 'common/entities/event/selectors';
import {
    getCanUserApplyFormsUserPermission,
    getCanUserCreateLibraryFormsUserPermission,
    getCanUserDeleteLibraryFormsUserPermission,
    getCanUserUpdateLibraryFormsUserPermission,
    getCanUserViewLibraryFormsUserPermission,
} from 'common/store/userPermissions/selectors';

import { isFormTypeRsvp } from 'common/entities/form/selectors';

import { DEFAULT } from '../reducers';
import { reducerNamespace } from '../constants/reducerNamespace';

const getFormLibraryState = (state) => state[reducerNamespace];

export const getFormLibraryList = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'formList', []);
};

export const getFormLibraryPage = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'page', 0);
};

export const getStatus = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'status', DEFAULT);
};

export const getPageLimitReached = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'pageLimitReached', false);
};

export const getSearchTerm = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'searchTerm', '');
};

export const getOpenSettingsModalId = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'openSettingsModalId', '');
};

export const getOpenDeletionModalId = (state) => {
    const formLibraryState = getFormLibraryState(state);
    return get(formLibraryState, 'openDeletionModalId', null);
};

/**
 * @param {Object} state
 * @return {boolean} isUserInEventOrg
 */
const getIsUserInEventOrg = (state) => {
    const userOrgId = getUserOrgId(state);
    const eventId = getEventId(state);
    const eventOrgId = getEventOrgId(state, eventId);
    return userOrgId === eventOrgId;
};

export const getHasAccessToLibraryComponents = createSelector(
    isFormTypeRsvp,
    getIsUserInEventOrg,
    (isFormRSVP, isUserOrgEventOrg) => isFormRSVP && isUserOrgEventOrg,
);

export const getHasAccessTopLevelFormLibraryWithRBAC = createSelector(
    getCanUserCreateLibraryFormsUserPermission,
    getCanUserDeleteLibraryFormsUserPermission,
    getCanUserViewLibraryFormsUserPermission,
    getCanUserApplyFormsUserPermission,
    getCanUserUpdateLibraryFormsUserPermission,
    (canCreate, canDelete, canView, canApply, canUpdate) => canCreate && canDelete && canView && canApply && canUpdate,
);
